module.exports = __webpack_public_path__ + "static/media/foundationcourse.6b279e60.png";